<template>
  <v-layout>
    <v-dialog v-model="dialog" max-width="80%" scrollable>
      <v-card>
        <v-card-text class="text-xs-left dlgTitle py-4">
          E-Mail versenden
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col xs="6">
              <v-row>
                <v-col>
                  <v-select
                      v-model="mailTemplate"
                      :items="mails"
                      outlined
                      @change="updateMailTemplate"
                      return-object
                      item-value="guid"
                      item-text="name"
                      label="Mail Template wählen"
                  ></v-select>
                </v-col>
                <v-col cols="12" align="start">
                  Bitte geben Sie hier Ihren E-Mail Text ein
                </v-col>
                <v-col cols="12" align="center">
                  <v-text-field v-model="item.to" label="Empfänger"></v-text-field>
                </v-col>
                <v-col cols="12" align="center">
                  <v-text-field v-model="item.subject" label="Betreff"></v-text-field>
                </v-col>
                <v-col cols="12" align="center">
                  <v-textarea auto-grow v-model="item.message" label="Text"></v-textarea>
                  <v-tabs
                      v-model="tab"
                      background-color="#EEEEEE"
                      color="black"
                      grow
                      v-if="false"
                  >
                    <v-tab key="dtab0" href="#dtab0">Template</v-tab>
                    <v-tab key="dtab1" href="#dtab1">Preview</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab" v-if="false">
                    <v-tab-item key="dtab0" value="dtab0">
                      <v-textarea auto-grow v-model="oldMessage" label="Text"></v-textarea>
                    </v-tab-item>
                    <v-tab-item key="dtab1" value="dtab1">
                      <v-textarea auto-grow v-model="item.message" label="Text"></v-textarea>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-col>
            <v-col xs="6" v-if="item.extra">
              <v-row v-for="(extra,i) in item.extra" v-bind:key="i">
                <v-col cols="12" xs="12">
                  <v-btn small @click="updateExtraText(extra)">preview</v-btn><v-checkbox v-model="extra.checked" :label="extra.name + ' ' + extra.mail"></v-checkbox>
                </v-col>
                <v-col cols="12" xs="12">
                  <p v-for="(device,d) in extra.devices" v-bind:key="d">{{device.name}}</p>
                </v-col>

              </v-row>
            </v-col>
          </v-row>
          <v-row>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog=false" color="primary" outlined>Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="doItem()" color="primary">
            versenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import _ from "lodash";
import Vue from "vue";

export default {
  name: 'DialogSendEmail',
  components: {},
  data() {
    return {
      dialog: false,
      tab: 'dtab0',
      oldMessage: '',
      mails: [],
      mailTemplate: null,
      actioNames: [{
        value: 'manual',
        text: 'Default'
      },{
        value: 'phone',
        text: 'Telefonat'
      },{
        value: 'mail',
        text: 'E-mail'
      },{
        value: 'contact',
        text: 'Kontakt'
      }],
      item: {
        from: '',
        to: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    updateMailTemplate: function () {
      console.log('updateMailTemplate', this.mailTemplate, this.item)
      this.oldMessage = this.mailTemplate.body
      this.item.subject = this.mailTemplate.subject
      this.item.message = this.mailTemplate.body

      if (Object.keys(this.item.extra) && (Object.keys(this.item.extra).length === 1) ) {
        this.item.extra[Object.keys(this.item.extra)[0]].checked = true
      }
    },
    open: function (mail) {
      this.dialog = true
      this.item = {
        subject: 'Neue E-mail',
      }
      if (mail) {
        this.item = mail
        this.oldMessage = mail.message
      }
      var reqData = {

      }

      Vue.prototype.$api.getMailsWithFilter(reqData, this.onGetMails)
    },
    onGetMails: function(mails) {
      this.mails = mails
      if (this.mails.length > 0) {
        this.mailTemplate = this.mails[0]
        this.updateMailTemplate()
      }
    },
    updateExtraText: function (extra) {
      this.item.message = this.oldMessage
      var txt = ''
      _.forEach(extra.devices, function (device) {
        txt += device.name + '\n'
      })
      this.item.message = this.oldMessage.replace("[EXTRA_DATA]", txt)
      this.item.subject = this.item.subject.replace("[EXTRA_DATA]", txt)
      this.item.to = extra.mail
      this.tab = 'dtab1'
    },
    doItem: function () {
      this.dialog = false
      this.item.message = this.item.message.replaceAll("\n", "<br>")
      this.$emit('sendMail', this.item)
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
